app.service('basketAccessorySearch', function (modal, pageConfig, basketAnalytics, carouselSlider, broker,
	productDetailsModal, simpleToastr, cartManager, toCartError) {
	const ACCESSORIES_SEARCH_MODAL = 'accessories-search-modal';
	let $self, $searchModalContent, $searchTabs, $searchTabsContents, $searchTabsButtons, $searchInput, $searchInputClearButton;
	let $ajax, isOneInit = false, activeTab = false, addedAccessories = [];

	function checkIfAlreadyLoaded() {
		const $currentTab = $searchTabsContents.filter('[data-tab-id="' + activeTab + '"]');
		return $currentTab.length && $currentTab.hasClass('loaded');
	}

	function showSearchTabContent() {
		$searchTabsContents.removeClass('active').filter('[data-tab-id="' + activeTab + '"]').addClass('active');
	}

	function setActiveTab(tabId) {
		if (activeTab === tabId) {
			console.log('Nie ponawiamy kliknięcia na już aktywną kartę');
			return;
		}
		activeTab = tabId;
		
		let $activeTabButton = $searchTabsButtons.filter('[data-tab-id="' + tabId + '"]');
		if(!$activeTabButton.length) {
			$activeTabButton = $searchTabsButtons.first();
			activeTab = $activeTabButton.data('tab-id');
		}

		if ($activeTabButton.length) {
			$searchTabsButtons.removeClass('active').attr('aria-selected', 'false');
			$activeTabButton.addClass('active').attr('aria-selected', 'true');
			const productIds = $activeTabButton.data('product-ids');
			loadProductGroupAccessories(productIds);
		}
	}

	function setAlreadyAddedAccessories() {
		const basket = pageConfig.getData('basket');
		if (basket.items && basket.items.length) {
			basket.items.forEach(function (item) {
				const $accessoryItem = $self.find('.accessory-search-item[data-accessory-id="' + item.id + '"]');
				$accessoryItem.find('.js-add-search-accessory-to-cart').text('Dodany').prop('disabled', true).addClass('added');
			});
		}
	}

	function loadProductGroupAccessoriesSuccess(html) {
		const $currentTab = $searchTabsContents.filter('[data-tab-id="' + activeTab + '"]');
		const inputValue = $currentTab.find('.accessory-search-input-row input').val();
		if($currentTab.length) {
			$currentTab.find('.accessory-search-results').html(html ? html : '<p>Brak akcesoriów dla tej kategorii.</p>');
			searchContent(inputValue);
			showSearchTabContent();
			setAlreadyAddedAccessories();
			$currentTab.addClass('loaded');
		}
	}

	function loadProductGroupAccessories(productIds) {
		if (checkIfAlreadyLoaded()) {
			showSearchTabContent();
			return;
		}
		if ($ajax) {
			$ajax.abort();
		}
		$searchModalContent.addClass('loading');
		$ajax = $.ajax({
			url: '/web-cached/cart-accessories-for-search.ltr',
			data: {
				'productIds': productIds
			},
			success: function (html) {
				loadProductGroupAccessoriesSuccess(html);
			},
			error: function () {
				modal.alert('Nie można otworzyć wyszukiwarki akcesoriów. Prosimy spróbować ponownie później.');
			}
		}).always(function () {
			$searchModalContent.removeClass('loading');
		});
	}

	function open(initTab = false) {
		const $SearchModalContent = $('#cart-accessories-search-modal-content');
		if (!$SearchModalContent.length) {
			modal.open(ACCESSORIES_SEARCH_MODAL);
			if(initTab) {
				setActiveTab(initTab);
			}
		} else {
			const searchModalHtml = $SearchModalContent.html();
			$SearchModalContent.remove();
			modal.generate({
				id: ACCESSORIES_SEARCH_MODAL,
				modifier: 'remodal-right',
				content: searchModalHtml,
				callbackOpen: function () {
					setElements();
					setEvents(initTab);
				},
				callbackClose: function () {
					if ($ajax) {
						$ajax.abort();
					}
					if (addedAccessories.length) {
						addedAccessories = [];
						broker.trigger('REFRESH_BASKET_VIEW');
					}
				}
			});
		}
	}

	function addFromSearch(params) {
		// TODO będzie wymagało poprawy po wdrożeniu zmian dla shopEventów na całej ścieżce
		const logEventData = {
			id: 'to_cart',
			f03: 'cart_step_1',
			f04: params.productPlu,
			f05: 'akc',
			f06: '',
			f07: 'accessory_card_search',
			f08: 'fancybox',
			f09: 'new',
			f10: '',
			f12: params.productPrice
		};

		cartManager.simpleAddProduct({
			productId: params.productId,
			addedFrom: 'CART_EDIT',
		}, params.callbackAdded, logEventData,
			function (json) {
				const cartErrorData = {
					productId: params.productId,
					productStatus: 'new',
					paymentType: '', // TODO params.isInstalmentPrice ? 'installment' : 'cash',
					errorMessage: json.notPossibleAddToCartReason || 'other',
					callFromElement: 'fancybox',
					productType: 'akc',
					isOperatorMode: pageConfig.isOperatorMode,
				}
				toCartError.sendEventAddToCartError(cartErrorData);
			}
		);
	}

	function searchContent(inputValue = '') {
		const $accessorySearchTabContent = $self.find('.accessory-search-tab-content[data-tab-id="' + activeTab + '"]');
		const searchText = inputValue.trim();
		const $searchClearButton = $accessorySearchTabContent.find('.search-input-clear-button');
		const $accessorySearchMessage = $accessorySearchTabContent.find('.accessory-search-results-message');

		const $accessorySearchItem = $accessorySearchTabContent.find('.accessory-search-item');
		if (searchText.length > 0) {
			let visibleCount = 0;
			$searchClearButton.addClass('show');
			$accessorySearchItem.each(function () {
				const $item = $(this);
				const itemText = $item.find('.accessory-description').text().replace(/\s+/g, ' ').toLowerCase(); // z pomijaniem kilkukrotnych spacji
				if (itemText.includes(searchText.toLowerCase())) {
					$item.addClass('show');
					visibleCount++;
				} else {
					$item.removeClass('show');
				}
			});
			if (visibleCount > 0) {
				const textEnding = visibleCount == 1 ? 'pasujący produkt' : (visibleCount < 5 || (visibleCount > 20 && visibleCount % 10 >= 2 && visibleCount % 10 < 5)) ? 'pasujące produkty' : 'pasujących produktów';
				$accessorySearchMessage.html('Znaleziono ' + visibleCount + ' ' + textEnding);
			} else {
				$accessorySearchMessage.html(`
					<div class="accessory-search-no-results">Nie znaleziono pasujących akcesoriów dla: <span class="missing-search-text">"${searchText}"</span></div>
					<div>Wyszukiwanie obejmuje tylko akcesoria do wybranego produktu.</div>
				`);
			}
			$accessorySearchMessage.addClass('show');
		} else {
			$accessorySearchItem.addClass('show');
			$searchClearButton.removeClass('show');
			$accessorySearchMessage.removeClass('show');
		}
	}

	function init() {
		if (!isOneInit) {
			isOneInit = true;

			broker.on('RELOAD_CART_SUCCESS', function () {
				modal.destroy(ACCESSORIES_SEARCH_MODAL);
				activeTab = false;
			});
		}
	}

	function setElements() {
		$self = $('#accessories-search-modal');
		$searchModalContent = $('.modal-content', $self);
		$searchTabs = $('#accessory-search-tabs', $self);
		$searchTabsContents = $self.find('.accessory-search-tab-content');
		$searchTabsButtons = $searchTabs.find('.js-accessories-search-tab');
		$searchInput = $self.find('.accessory-search-input-row input');
		$searchInputClearButton = $self.find('.js-accessory-search-clear');
	}

	function setEvents(initTab) {
		carouselSlider.init($searchTabs);

		$searchTabsButtons.on('click', function () {
			setActiveTab($(this).data('tab-id'));
		});

		$searchInput.on('input change paste', function () {
			searchContent($(this).val());
		});

		$searchInputClearButton.on('click', function () {
			const $input = $(this).siblings('input');
			$input.val('').trigger('change');
		});

		if(initTab && initTab > 0) {
			setActiveTab(initTab);
		} else {
			setActiveTab($searchTabsButtons.first().data('tab-id'));
		}

		$searchTabsContents.on('click', '.js-add-search-accessory-to-cart', function () {
			const $addToCartButton = $(this);
			const $accessorySearchItem = $addToCartButton.closest('.accessory-search-item');
			const productName = $accessorySearchItem.find('.accessory-description').text().trim();
			const productPlu = $accessorySearchItem.data('accessory-plu');
			const productId = $accessorySearchItem.data('accessory-id');
			addFromSearch({
				productId: productId,
				productPlu: productPlu,
				callbackAdded: function () {
					basketAnalytics.addProduct(productPlu, 'accessory_card_search');
					simpleToastr.generate(`<h2>Produkt dodany do koszyka</h2><p>${productName}</p>`);
					$addToCartButton.text('Dodany').prop('disabled', true).addClass('added');
					addedAccessories.push(productId);
				}
			});
		}).on('click', '.js-search-accessory-details', function () {
			const $accessorySearchItem = $(this).closest('.accessory-search-item');
			const productName = $accessorySearchItem.find('.accessory-description').text().trim();
			const $addToCartButton = $accessorySearchItem.find('.js-add-search-accessory-to-cart');
			const productPlu = $accessorySearchItem.data('accessory-plu');
			const productId = $accessorySearchItem.data('accessory-id');
			productDetailsModal.open({
				openAsInnerModal: 'inner-modal-product-details',
				productId: productId,
				productPlu: productPlu,
				callbackAdded: function () {
					modal.closeInternal();
					basketAnalytics.addProduct(productPlu, 'accessory_card');
					simpleToastr.generate(`<h2>Produkt dodany do koszyka</h2><p>${productName}</p>`);
					$addToCartButton.text('Dodany').prop('disabled', true).addClass('added');
					addedAccessories.push(productId);
				},
				productDetailsModalOpen: function () {
					productDetailsModal.setAddToCartButton({ isAdded: $addToCartButton.hasClass('added') });
				}
			});
			UA.interaction('Koszyk - K1', 'Warstwa ze szczegółami akcesorium z widoku wyszukiwania akcesorium', 'Kliknięcie');
		});
	}

	return {
		init,
		open
	};
});
